const intersectionObserver = (
    node: HTMLElement,
    options?: IntersectionObserverInit
) => {
    if (!node) return;

    const callback = (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => {
            const event = entry.isIntersecting
                ? "viewportEnter"
                : "viewportLeave";

            entry.target.dispatchEvent(new CustomEvent(event));
        });
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(node);

    return {
        destroy() {
            observer.unobserve(node);
        },
    };
};

export default intersectionObserver;
